<template>
  <div>
    <div class="candidate-navbar">
      <button class="btn-menu" id="open-menu" data-target="#collapse-menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <ul class="menu" id="collapse-menu">
        <li>
          <router-link :to="{ path: '/candidate/dl' }"
            >DL 履歷 {{ resumeCompleteness.DLCompleteness }}%</router-link
          >
        </li>
        <li>
          <router-link :to="{ path: '/candidate/idl' }"
            >IDL 履歷 {{ resumeCompleteness.IDLCompleteness }}%</router-link
          >
        </li>
        <li>
          <router-link :to="{ path: '/candidate/jobopening' }"
            >職缺列表</router-link
          >
        </li>
        <li>
          <router-link :to="{ path: '/candidate/applicationrecord' }"
            >應徵紀錄</router-link
          >
        </li>
        <li>
          <button type="button" @click="openChangePasswordModal">
            變更密碼
          </button>
        </li>
        <li><button type="button" @click="logout">登出</button></li>
      </ul>
    </div>

    <!-- 變更密碼 Modal -->
    <div
      class="modal fade"
      id="changePasswordByOneself"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <img class="password_bg" src="@/assets/img/password_bg.png" alt="" />
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="changePassword"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            @submit.prevent="handleSubmit(changePassword)"
            @reset.prevent="reset"
          >
            <img class="password_bg_02" src="@/assets/img/password_bg_02.png" alt="" />
            <div class="modal-header">
              <span>變更密碼</span>
            </div>
            <div class="modal-body">
              <div class="form-group form">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  請輸入舊密碼
                </label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <input
                    type="password"
                    v-model.trim="changePasswordData.CurrentPassword"
                  />
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for="">
                  <span class="mark">*</span>
                  請輸入新密碼<span class="mark">(長度須大於等於8)</span>
                </label>
                <ValidationProvider
                  name="新密碼"
                  vid="confirmation"
                  rules="required|password_length:8"
                  v-slot="{ errors }"
                >
                  <input
                    type="password"
                    v-model.trim="changePasswordData.NewPassword"
                  />
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  確認新密碼
                </label>
                <ValidationProvider
                  name="確認新密碼"
                  rules="required|confirmed:confirmation"
                  v-slot="{ errors }"
                >
                  <input
                    type="password"
                    v-model.trim="changePasswordData.ConfirmPassword"
                  />
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                取消
              </button>
              <button type="submit" class="btn btn-success">儲存</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 同步104履歷 Modal -->
    <div id="syncResumeModal" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <ValidationObserver
            ref="syncResume"
            class="modal-content"
            v-slot="{ handleSubmit }"
          >
            <div class="modal-header">
              <h5 class="modal-title">同步104履歷功能</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  name="帳號"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <label for="">
                    <span class="mark">*</span>
                    104 帳號：
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="syncData.User104Account"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="密碼"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <label for="">
                    <span class="mark">*</span>
                    104 密碼：
                  </label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="syncData.User104Password"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <p class="mark">
                本功能不會留存您的帳號、密碼。<br />
                本功能無法同步使用Facebook註冊的104帳號，請見諒。
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSubmit(syncResume)"
              >
                同步
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";
export default {
  name: "candidateNavBar",

  data() {
    return {
      changePasswordData: {},
      // 104
      syncData: {},
      syncMessage: "",
    };
  },

  methods: {
    // 登出
    logout() {
      this.$api.logout
        .logout({
          token: this.$cookies.get("AUTH_TOKEN"),
        })
        .then((response) => {
          if (response.status === 200) {
            let language = localStorage.getItem("i18n-lang");
            localStorage.clear();
            localStorage.setItem("i18n-lang", language);
            this.$cookies
              .keys()
              .forEach((cookie) => this.$cookies.remove(cookie));
            this.$router.push({ path: "/signIn" });
          }
        });
    },

    // 變更密碼 Modal
    openChangePasswordModal() {
      this.changePasswordData = {};
      this.$refs.changePassword.reset();
      $("#changePasswordByOneself").modal("show");
    },

    // 變更密碼 API
    changePassword() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/user/ChangePasswordByOneself`;

      const data = {
        Account: vm.$cookies.get("candidateAccount"),
        ...vm.changePasswordData,
      };

      $("#changePasswordByOneself").modal("hide");
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "密碼變更成功",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 同步104履歷
    syncResume() {
      $("#syncResumeModal").modal("hide");
      this.$store.dispatch("updateLoading", true);
      this.$api.c104
        .postResumeCrawlJob({
          userId: this.$cookies.get("candidateId"),
          ...this.syncData,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              dangerouslyUseHTMLString: true,
              title: "同步中",
              message:
                "同步履歷約需10分鐘至1小時。<br/>完成時，將立即Email通知您。",
              type: "success",
              duration: 2500,
            });
            this.$store.dispatch("updateLoading", false);
          }
        });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["resumeCompleteness"]),
  },

  mounted() {
    $(document).ready(function () {
      $("#open-menu").on("click", function () {
        let target = $(this).attr("data-target");
        if ($(target).hasClass("open")) {
          $(target).removeClass("open");
        } else {
          $(target).addClass("open");
        }
      });

      $(window).on("load resize", windowSize);

      function windowSize() {
        if ($(window).width() > "991") {
          let menu = $("#open_menu").attr("data-target");
          $(menu).removeClass("open");
        }
      }
    });
  },

  created() {
    this.$store.dispatch("GetResumeCompleteness");
  },

  destroyed() {
    this.$notify.close();
  },
};
</script>

<!-- <style lang="scss" scoped>
.candidate-navbar {
  background-color: #ffffff;
  position: relative;
  &::before,
  &::after {
    content: " ";
    display: table;
  }
  &::after {
    clear: both;
  }
  @media screen and (max-width: 767px) {
    height: 80px;
    padding: 20px 10px;
    min-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  // .btn-menu {
  //   display: none;
  //   height: 40px;
  //   background-color: #ffffff;
  //   border: none;
  //   outline: none;
  //   position: absolute;
  //   left: 25px;
  //   cursor: pointer;
  //   span {
  //     background-color: #333333;
  //     width: 20px;
  //     height: 2px;
  //     display: block;
  //     & + span {
  //       margin-top: 4px;
  //     }
  //   }
  //   @media screen and (max-width: 991px) {
  //     display: block;
  //   }
  // }

  .menu {
    list-style-type: none;
    text-align: center;
    float: right;
    @media screen and (max-width: 991px) {
      display: none;
      position: absolute;
      top: 80px;
      left: 0;
      right: 0;
      text-align: center;
      background-color: #ffffff;
      border-top: 1px solid #333;
      padding: 0 10px 0 10px;
      z-index: 999;
    }
    &.open {
      display: block;
    }
    li {
      display: inline-block;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
      @media screen and (max-width: 991px) {
        display: block;
        margin-right: 0;
        padding: 5px 25px;
        &:not(:last-child) {
          border-bottom: 1px solid rgba(#333, 0.3);
        }
      }
      // .nav-btn {
      //   background-color: transparent;
      //   border: none;
      //   font-size: 0.9em;
      //   height: 35px;
      //   line-height: 35px;
      //   border-radius: 0.25rem;
      //   transition: all 0.3s;
      //   margin-right: 10px;

      //   &:focus {
      //     outline: none;
      //   }
      //   &:active {
      //     outline: none;
      //   }

      //   &:hover {
      //     background-color: rgba(0, 0, 0, 0.1);
      //   }
      // }
    }
  }
}
</style> -->
